import { defineMessages } from 'react-intl';

export default defineMessages({
    policyDocsHeading: {
        id: 'custom.views.preferences.Policy Documents',
        defaultMessage: 'Policy Documents'
    },
    policyDocsHeading2: {
        id: 'custom.views.preferences.How would you like to receive your policy documents?',
        defaultMessage: 'How would you like to receive your policy documents?'
    },
    policyDocsNote: {
        id: 'custom.views.preferences.NoteMsg',
        defaultMessage: 'Please note: Document preferences can only be updated for policies paid directly to Heartland Farm Mutual Insurance.For policies paid to your broker, please contact your broker directly.'
    },
    policyType: {
        id: 'custom.views.preferences.Policy Type',
        defaultMessage: 'Policy Type'
    },
    policyNumber: {
        id: 'custom.views.preferences.Policy Number',
        defaultMessage: 'Policy Number'
    },
    documentPreference: {
        id: 'custom.views.preferences.Document Preference',
        defaultMessage: 'Document Preference'
    },
    policyDocEmailConsent: {
        id: 'custom.views.preferences.policyDocEmailConsentMsg',
        defaultMessage: 'I agree to receiving emails from Heartland Farm Mutual Insurance and/or Kings Mutual Insurance regarding my policy documents.'
    },
    saveChanges: {
        id: 'custom.views.paperless.Save Changes',
        defaultMessage: 'Save Changes'
    },
    saveDocPreferenceSuccess: {
        id: 'custom.views.preferences.Policy Document preferences are successfully updated.',
        defaultMessage: 'Policy Document preferences are successfully updated.'
    },
    saveDocPreferenceError: {
        id: 'custom.views.preferences.Failed to update Document preferences details.',
        defaultMessage: 'Failed to update Document preferences details.'
    },
    policyConsentSelectWarning: {
        id: 'custom.views.preferences.Consent Select Warning',
        defaultMessage: 'Please select consent checkbox to receive policy documents via emails'
    },
    agree: {
        id: 'custom.views.paperless.Agree',
        defaultMessage: 'I Agree to Electronic Delivery'
    },
    renewalDocPrefrence:{
        id: 'custom.views.paperless.Renewal Document Prefernce',
        defaultMessage: 'Renewal Document Prefernce'
    }
});
